import { useRef } from "react";

const TintedImage = ({
  src,
  color,
  color2,
  gradientAngle = 90,
  alt,
  className,
  style,
  ...props
}) => {
  const instanceId = useRef(Math.random().toString(36).substr(2, 9)).current;
  const filterId = `tint-${instanceId}-${(color || "").replace("#", "")}-${(color2 || "").replace("#", "")}-${gradientAngle}`;

  const isWhite =
    !color ||
    color.toLowerCase() === "#ffffff" ||
    color.toLowerCase() === "#fff";

  if (isWhite) {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          ...style,
        }}
      >
        <img
          src={src}
          alt={alt || ""}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
          {...props}
        />
      </div>
    );
  }

  const hasGradient = !!color2;

  let filterInner;
  if (hasGradient) {
    const rad = (gradientAngle * Math.PI) / 180;
    const gx1 = (50 - Math.sin(rad) * 50).toFixed(1);
    const gy1 = (50 + Math.cos(rad) * 50).toFixed(1);
    const gx2 = (50 + Math.sin(rad) * 50).toFixed(1);
    const gy2 = (50 - Math.cos(rad) * 50).toFixed(1);
    const gradSvg = encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' width='1' height='1' viewBox='0 0 1 1' preserveAspectRatio='none'>` +
        `<defs><linearGradient id='g' x1='${gx1}%' y1='${gy1}%' x2='${gx2}%' y2='${gy2}%'>` +
        `<stop offset='0' stop-color='${color}'/>` +
        `<stop offset='1' stop-color='${color2}'/>` +
        `</linearGradient></defs>` +
        `<rect width='1' height='1' fill='url(#g)'/></svg>`,
    );
    filterInner = (
      <filter
        id={filterId}
        colorInterpolationFilters="sRGB"
        x="0%"
        y="0%"
        width="100%"
        height="100%"
      >
        <feImage
          href={`data:image/svg+xml,${gradSvg}`}
          preserveAspectRatio="none"
          result="gradient"
        />
        <feComposite
          in="gradient"
          in2="SourceAlpha"
          operator="in"
          result="colorMask"
        />
        <feBlend
          in="SourceGraphic"
          in2="colorMask"
          mode="multiply"
          result="blend"
        />
        <feComposite in="blend" in2="SourceAlpha" operator="in" />
      </filter>
    );
  } else {
    filterInner = (
      <filter id={filterId} colorInterpolationFilters="sRGB">
        <feFlood floodColor={color} result="flood" />
        <feComposite
          in="flood"
          in2="SourceAlpha"
          operator="in"
          result="colorMask"
        />
        <feBlend
          in="SourceGraphic"
          in2="colorMask"
          mode="multiply"
          result="blend"
        />
        <feComposite in="blend" in2="SourceAlpha" operator="in" />
      </filter>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        ...style,
      }}
    >
      <svg
        width="0"
        height="0"
        style={{ position: "absolute", pointerEvents: "none" }}
      >
        <defs>{filterInner}</defs>
      </svg>
      <img
        src={src}
        alt={alt || ""}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          filter: `url(#${filterId})`,
        }}
        {...props}
      />
    </div>
  );
};

export default TintedImage;
